import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { fieldHintId } from './fieldParts';

export interface FieldProps {
  id: string;
  label: string;
  /** Texte d'aide sous le champ, lié au contrôle par aria-describedby (fieldHintId) */
  hint?: ReactNode;
  error?: string;
  /** Champ obligatoire : « * » après le libellé (convention de l'application, jamais « (facultatif) » sur les autres) */
  required?: boolean;
  children: ReactNode;
}

/** « * » des champs obligatoires, hors du nom accessible (le contrôle porte aria-required) */
export function RequiredMark() {
  return (
    <span className="text-red-500 ml-0.5" aria-hidden>
      *
    </span>
  );
}

/** Champ de formulaire : libellé (petit, gris, en majuscules), contrôle, texte d'aide et message d'erreur */
export function Field({ id, label, hint, error, required, children }: FieldProps) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-xs font-semibold text-slate-500 uppercase">
        {label}
        {required && <RequiredMark />}
      </Label>
      {children}
      {hint && (
        <p id={fieldHintId(id)} className="text-xs text-slate-500">
          {hint}
        </p>
      )}
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
